"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateBooleanELMJSONFunction = exports.generateEpisodeELMJSONFunction = exports.setValueSetVersionsToUndefined = exports.createEpisodePopulationValues = exports.handleStratificationValues = exports.createPatientPopulationValues = exports.handleStandardPopulationValues = exports.handleCVPopulationValues = exports.handleRatioPopulationValues = exports.handlePopulationValues = exports.createPopulationValues = void 0;
const MeasureBundleHelpers = __importStar(require("../helpers/MeasureBundleHelpers"));
const DetailedResultsHelpers = __importStar(require("../helpers/DetailedResultsHelpers"));
const ClauseResultsBuilder_1 = require("./ClauseResultsBuilder");
const Enums_1 = require("../types/Enums");
/**
 * Create population values (aka results) for all populations in the population group using the results from the
 * calculator. This creates the DetailedPopulationGroupResult for the patient that will be filled by most of the
 * results processing functions.
 *
 * @param {fhir4.Measure} measure - The measure we are getting the values for.
 * @param {fhir4.MeasureGroup} populationGroup - The population group that we are creating results to.
 * @param {cql.StatementResults} patientResults - The raw results object from the calculation engine for a patient.
 * @returns {DetailedPopulationGroupResult} The population group results object with the populationResults, stratifierResults,
 *   and episodeResults (if episode of care measure) populated.
 */
function createPopulationValues(measure, populationGroup, patientResults) {
    let populationResults = [];
    let stratifierResults;
    let episodeResults;
    const measureScoringCode = MeasureBundleHelpers.getScoringCodeFromMeasure(measure);
    // patient based measure
    if (!MeasureBundleHelpers.isEpisodeOfCareGroup(measure, populationGroup)) {
        const popAndStratResults = createPatientPopulationValues(populationGroup, patientResults);
        populationResults = popAndStratResults.populationResults;
        stratifierResults = popAndStratResults.stratifierResults;
        populationResults = handlePopulationValues(populationResults, populationGroup, measureScoringCode);
        if (stratifierResults) {
            stratifierResults = handleStratificationValues(populationGroup, populationResults, stratifierResults);
        }
    }
    else {
        // episode of care based measure
        // collect results per episode
        episodeResults = createEpisodePopulationValues(populationGroup, patientResults, measureScoringCode);
        // if no episodes were found we need default populationResults/stratifierResults. Just use the patient
        // level logic for this
        if (episodeResults === undefined || episodeResults.length === 0) {
            episodeResults = [];
            const popAndStratResults = createPatientPopulationValues(populationGroup, patientResults);
            populationResults = popAndStratResults.populationResults;
            stratifierResults = popAndStratResults.stratifierResults;
            if (stratifierResults) {
                stratifierResults = handleStratificationValues(populationGroup, populationResults, stratifierResults);
            }
        }
        else {
            populationResults = [];
            stratifierResults = [];
            // create patient level population and stratifier results based on episodes
            episodeResults.forEach(episodeResult => {
                var _a;
                episodeResult.populationResults.forEach(popResult => {
                    var _a;
                    const measureObsPop = populationResults.find(pop => pop.populationType === Enums_1.PopulationType.OBSERV &&
                        popResult.criteriaExpression === pop.criteriaExpression &&
                        pop.criteriaReferenceId === popResult.criteriaReferenceId);
                    if (!measureObsPop) {
                        (0, ClauseResultsBuilder_1.createOrSetResult)(popResult.populationType, popResult.result, populationResults, popResult.criteriaExpression, popResult.populationId, popResult.criteriaReferenceId, popResult.observations);
                    }
                    else {
                        if (popResult.observations) {
                            // We are using .concat to avoid manipulating individual episode results as a side effect
                            measureObsPop.observations = ((_a = measureObsPop.observations) !== null && _a !== void 0 ? _a : []).concat(popResult.observations);
                        }
                        (0, ClauseResultsBuilder_1.setResult)(measureObsPop.populationType, popResult.result, populationResults, measureObsPop.criteriaExpression, measureObsPop.criteriaReferenceId);
                    }
                });
                (_a = episodeResult.stratifierResults) === null || _a === void 0 ? void 0 : _a.forEach(strat => {
                    const stratRes = stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.find(stratRes => stratRes.strataCode === strat.strataCode);
                    if (stratRes) {
                        if (strat.result === true) {
                            stratRes.result = true;
                        }
                    }
                    else {
                        stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.push(Object.assign({ result: strat.result, strataCode: strat.strataCode, appliesResult: strat.result }, (strat.strataId ? { strataId: strat.strataId } : {})));
                    }
                });
            });
            if (stratifierResults) {
                stratifierResults = handleStratificationValues(populationGroup, populationResults, stratifierResults);
            }
        }
    }
    const detailedResult = {
        groupId: populationGroup.id || 'unknown',
        statementResults: [],
        populationResults: populationResults,
        episodeResults: episodeResults,
        stratifierResults: stratifierResults
    };
    return detailedResult;
}
exports.createPopulationValues = createPopulationValues;
/**
 * Takes in the initial values from the population and checks to see if some values should not be calculated. These
 * values that should not be considered calculated are zeroed out. ex. results NUMER is true but IPP is false.
 * @param {PopulationResult[]} populationResults - The list of population results.
 * @param {fhir4.MeasureGroup} group - Full Measure Group used to detect multiple IPPs and resolve any references between populations
 * @param {string} measureScoringCode scoring code for measure (used if scoring code not provided at the group level)
 * @returns {PopulationResult[]} Population results in the list as passed in, but the appropriate values are zeroed out.
 */
function handlePopulationValues(populationResults, group, measureScoringCode) {
    /* Population logic guidance: https://mmshub.cms.gov/sites/default/files/Measure-Calculations.pdf
     * Follows population requirements in table 3-1 here: https://hl7.org/fhir/us/cqfmeasures/measure-conformance.html#data-criteria
     *
     * For proportional: Setting values of populations if the correct populations are not set based on the following logic guidelines
     * Initial Population (IPP): The set of patients or episodes of care to be evaluated by the measure.
     * Denominator (DENOM): A subset of the IPP.
     * Denominator Exclusions (DENEX): A subset of the Denominator that should not be considered for inclusion in the Numerator.
     * Denominator Exceptions (DEXCEP): A subset of the Denominator. Only those members of the Denominator that are considered
     * for Numerator membership and are not included are considered for membership in the Denominator Exceptions.
     * Numerator (NUMER): A subset of the Denominator. The Numerator criteria are the processes or outcomes expected for each patient,
     * procedure, or other unit of measurement defined in the Denominator.
     * Numerator Exclusions (NUMEX): A subset of the Numerator that should not be considered for calculation.
     *
     * For Ratio: the NUMER and DENOM are independent, and there may be multiple IPPs.
     *
     * For CV:
     * Measure Population (MSRPOPL): A subset of the IPP for continuous variable measures.
     * Measure Population Exclusions (MSRPOPLEX): A subset of the MSRPOPL that should not be considered for calculation.
     */
    if (MeasureBundleHelpers.isRatioMeasure(group, measureScoringCode)) {
        return handleRatioPopulationValues(populationResults, group);
    }
    else if (MeasureBundleHelpers.isCVMeasure(group, measureScoringCode)) {
        return handleCVPopulationValues(populationResults);
    }
    else {
        return handleStandardPopulationValues(populationResults, group);
    }
}
exports.handlePopulationValues = handlePopulationValues;
function handleRatioPopulationValues(populationResults, group) {
    const populationResultsHandled = populationResults;
    // Cannot be in all populations if not in IPP.
    if (MeasureBundleHelpers.hasMultipleIPPs(group)) {
        const numerRelevantIPP = MeasureBundleHelpers.getRelevantIPPFromPopulation(group, Enums_1.PopulationType.NUMER);
        if (numerRelevantIPP) {
            // Mark only numerator-relevant populations as false for this IPP
            if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults, numerRelevantIPP.criteria.expression) === false) {
                (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMER, false, populationResults);
                (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMEX, false, populationResults);
                DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.NUMER);
            }
        }
        const denomRelevantIPP = MeasureBundleHelpers.getRelevantIPPFromPopulation(group, Enums_1.PopulationType.DENOM);
        if (denomRelevantIPP) {
            // Mark only denominator-relevant populations as false for this IPP
            if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults, denomRelevantIPP.criteria.expression) === false) {
                (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENOM, false, populationResults);
                (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEX, false, populationResults);
                (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
                DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.DENOM);
            }
        }
        if (numerRelevantIPP &&
            !(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults, numerRelevantIPP.criteria.expression) &&
            denomRelevantIPP &&
            !(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults, denomRelevantIPP.criteria.expression)) {
            // Short-circuit return since no more processing needs to be done if both IPPs are false
            return populationResultsHandled;
        }
    }
    else if (!(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults)) {
        populationResults.forEach(result => {
            if (result.populationType === Enums_1.PopulationType.OBSERV) {
                result.observations = null;
            }
            result.result = false;
        });
        // Short-circuit return since no more processing needs to be done if IPP is false with only one IPP
        return populationResultsHandled;
    }
    // ratio measurement treats denom and numer as independent
    if ((0, ClauseResultsBuilder_1.hasResult)(Enums_1.PopulationType.DENOM, populationResults) && !(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.DENOM, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEX, false, populationResults);
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.DENOM);
        // Cannot be in the denominator exception if they are excluded from the denominator
    }
    else if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.DENEX, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
    }
    // Cannot be in the NUMEX if not in the NUMER
    if (!(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.NUMER, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMEX, false, populationResults);
        // Not in NUMER, so no need for NUMER observations
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.NUMER);
    }
    return populationResultsHandled;
}
exports.handleRatioPopulationValues = handleRatioPopulationValues;
function handleCVPopulationValues(populationResults) {
    const populationResultsHandled = populationResults;
    // Cannot be in all populations if not in IPP.
    if (!(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults)) {
        populationResults.forEach(result => {
            if (result.populationType === Enums_1.PopulationType.OBSERV) {
                result.observations = null;
            }
            result.result = false;
        });
        // Short-circuit return since no more processing needs to be done if IPP is false with only one IPP
        return populationResultsHandled;
    }
    // Cannot be in most populations if not in MSRPOPL
    if ((0, ClauseResultsBuilder_1.hasResult)(Enums_1.PopulationType.MSRPOPL, populationResults) && !(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.MSRPOPL, populationResults)) {
        // If a result exists for the MSRPOPL, all observations point to it, so null them out
        const popResult = populationResults.find(result => result.populationType === Enums_1.PopulationType.OBSERV);
        if (popResult) {
            popResult.result = false;
            popResult.observations = null;
        }
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.MSRPOPLEX, false, populationResults);
        // Cannot have observations if in the MSRPOPLEX
    }
    else if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.MSRPOPLEX, populationResults)) {
        const popResult = populationResults.find(result => result.populationType === Enums_1.PopulationType.OBSERV);
        if (popResult) {
            popResult.result = false;
            popResult.observations = null;
        }
    }
    return populationResultsHandled;
}
exports.handleCVPopulationValues = handleCVPopulationValues;
function handleStandardPopulationValues(populationResults, group) {
    // proportional/cohort handling
    const populationResultsHandled = populationResults;
    // Cannot be in all populations if not in IPP.
    if (!(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.IPP, populationResults)) {
        populationResults.forEach(result => {
            if (result.populationType === Enums_1.PopulationType.OBSERV) {
                result.observations = null;
            }
            result.result = false;
        });
        // Short-circuit return since no more processing needs to be done if IPP is false with only one IPP
        return populationResultsHandled;
    }
    // Cannot be in most populations if not in DENOM or MSRPOPL
    if ((0, ClauseResultsBuilder_1.hasResult)(Enums_1.PopulationType.DENOM, populationResults) && !(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.DENOM, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEX, false, populationResults);
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.DENOM);
        // If the numer is influenced by the DENOM, false it out and its observations since we are not in the DENOM for this branch of logic
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMER, false, populationResults);
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMEX, false, populationResults);
        // If there are not multiple IPPs, then NUMER depends on DENOM. We're not in the DENOM, so let's null out NUMER observations
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.NUMER);
        // Cannot be in the numerator if they are excluded from the denominator
    }
    else if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.DENEX, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMER, false, populationResults);
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMEX, false, populationResults);
        // Since we can't be in the numerator, null out numerator observations
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.NUMER);
        // Cannot be in the denominator exception if in the denominator exclusion
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
        // Cannot be in the NUMEX if not in the NUMER
    }
    else if (!(0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.NUMER, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.NUMEX, false, populationResults);
        // Not in NUMER, so no need for NUMER observations
        DetailedResultsHelpers.nullCriteriaRefMeasureObs(group, populationResults, Enums_1.PopulationType.NUMER);
        // Cannot be in the DENEXCEP if in the NUMER
    }
    else if ((0, ClauseResultsBuilder_1.getResult)(Enums_1.PopulationType.NUMER, populationResults)) {
        (0, ClauseResultsBuilder_1.setResult)(Enums_1.PopulationType.DENEXCEP, false, populationResults);
    }
    return populationResultsHandled;
}
exports.handleStandardPopulationValues = handleStandardPopulationValues;
/**
 * Create patient population values (aka results) for all populations in the population group using the results from the
 * calculator.
 * @param {fhir4.MeasureGroup} populationGroup - The population group we are getting the values for.
 * @param {cql.StatementResults} patientResults - The raw results object for a patient from the calculation engine.
 * @returns {PopulationResult[]} The population results list.
 */
function createPatientPopulationValues(populationGroup, patientResults) {
    var _a;
    const populationResults = [];
    // Loop over all populations ("IPP", "DENOM", etc.)
    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(population => {
        const cqlPopulation = population.criteria.expression;
        // Is there a patient result for this population? and does this populationCriteria contain the population
        // We need to check if the populationCriteria contains the population so that a STRAT is not set to zero if there is not a STRAT in the populationCriteria
        // Grab CQL result value and adjust for ECQME
        const populationType = MeasureBundleHelpers.codeableConceptToPopulationType(population.code);
        // If this is a valid population type and there is a defined cql population pull out the values
        if (populationType != null && cqlPopulation != null) {
            // For measure observations observing a boolean population, match the result with the population it is observing
            // and pull the observations from the generated ELM JSON function with no parameters
            if (populationType === Enums_1.PopulationType.OBSERV) {
                const observingPopulation = DetailedResultsHelpers.findObsMsrPopl(populationGroup, population);
                const value = (observingPopulation === null || observingPopulation === void 0 ? void 0 : observingPopulation.criteria.expression)
                    ? patientResults[observingPopulation.criteria.expression]
                    : null;
                const result = isStatementValueTruthy(value);
                const observRawResult = patientResults[`obs_func_${cqlPopulation}`];
                const newPopulationResult = {
                    populationType: populationType,
                    criteriaExpression: population.criteria.expression,
                    result
                };
                DetailedResultsHelpers.addIdsToPopulationResult(newPopulationResult, population);
                if (observRawResult) {
                    newPopulationResult.observations = [observRawResult];
                }
                populationResults.push(newPopulationResult);
            }
            else {
                const value = patientResults[cqlPopulation];
                const result = isStatementValueTruthy(value);
                const newPopulationResult = {
                    populationType: populationType,
                    criteriaExpression: population.criteria.expression,
                    result: result
                };
                DetailedResultsHelpers.addIdsToPopulationResult(newPopulationResult, population);
                populationResults.push(newPopulationResult);
            }
        }
    });
    // Loop over all stratifiers if there are any an collect results
    let stratifierResults;
    if (populationGroup.stratifier) {
        stratifierResults = [];
        // index used in case the text for the stratifier could not be found
        let strataIndex = 1;
        populationGroup.stratifier.forEach(strata => {
            var _a, _b, _c, _d, _e;
            if ((_a = strata.criteria) === null || _a === void 0 ? void 0 : _a.expression) {
                const value = patientResults[(_b = strata.criteria) === null || _b === void 0 ? void 0 : _b.expression];
                const result = isStatementValueTruthy(value);
                stratifierResults === null || stratifierResults === void 0 ? void 0 : stratifierResults.push(Object.assign({ strataCode: (_e = (_d = (_c = strata.code) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : strata.id) !== null && _e !== void 0 ? _e : `strata-${strataIndex++}`, result, appliesResult: result }, (strata.id ? { strataId: strata.id } : {})));
            }
        });
    }
    return {
        populationResults,
        stratifierResults
    };
}
exports.createPatientPopulationValues = createPatientPopulationValues;
function handleStratificationValues(populationGroup, populationResults, stratifierResults) {
    if (populationGroup.stratifier) {
        stratifierResults.forEach(stratRes => {
            var _a, _b, _c, _d, _e, _f, _g;
            const strata = ((_a = populationGroup.stratifier) === null || _a === void 0 ? void 0 : _a.find(s => s.id === stratRes.strataCode)) ||
                ((_b = populationGroup.stratifier) === null || _b === void 0 ? void 0 : _b.find(s => s.code && s.code.text === stratRes.strataCode));
            if (strata) {
                // if the cqfm-appliesTo extension is present, then we want to consider the result of that
                // population in our stratifier result
                const appliesToExtension = (_c = strata.extension) === null || _c === void 0 ? void 0 : _c.find(e => e.url === 'http://hl7.org/fhir/us/cqfmeasures/StructureDefinition/cqfm-appliesTo');
                let popValue = true;
                if (appliesToExtension) {
                    const popCode = (_e = (_d = appliesToExtension.valueCodeableConcept) === null || _d === void 0 ? void 0 : _d.coding) === null || _e === void 0 ? void 0 : _e[0].code;
                    if (popCode) {
                        popValue = (_g = (_f = populationResults.find(pr => pr.populationType === popCode)) === null || _f === void 0 ? void 0 : _f.result) !== null && _g !== void 0 ? _g : true;
                    }
                }
                stratRes.appliesResult = popValue && stratRes.result;
            }
        });
    }
    return stratifierResults;
}
exports.handleStratificationValues = handleStratificationValues;
function isStatementValueTruthy(value) {
    if (Array.isArray(value) && value.length > 0) {
        return true;
    }
    else if (typeof value === 'boolean' && value === true) {
        return true;
    }
    else {
        return false;
    }
}
/**
 * Create population results for all episodes using the results from the calculator. This is
 * used only for the episode of care measures.
 * @param {fhir4.MeasureGroup} populationGroup - The population group we are getting the values for.
 * @param {cql.StatementResults} patientResults - The raw results object for the patient from the calculation engine.
 * @param {string} measureScoringCode scoring code for measure (used if scoring code not provided at the group level)
 * @returns {EpisodeResults[]} The episode results list. Structure with episode id population results for each episode.
 *   If this is a continuous variable measure the observations are included.
 */
function createEpisodePopulationValues(populationGroup, patientResults, measureScoringCode) {
    var _a, _b;
    const episodeResultsSet = [];
    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(population => {
        const cqlPopulation = population.criteria.expression;
        const populationType = MeasureBundleHelpers.codeableConceptToPopulationType(population.code);
        // If this is a valid population type and there is a defined cql population pull out the values
        if (populationType != null && cqlPopulation != null) {
            // handle observation population
            if (populationType === Enums_1.PopulationType.OBSERV) {
                // find the MSRPOPL for this population because we need to know its name
                const msrPopl = DetailedResultsHelpers.findObsMsrPopl(populationGroup, population);
                if (msrPopl === null || msrPopl === void 0 ? void 0 : msrPopl.criteria.expression) {
                    const episodesRawResults = patientResults[`obs_func_${cqlPopulation}_${msrPopl === null || msrPopl === void 0 ? void 0 : msrPopl.criteria.expression}`];
                    // loop through observation results and create observations
                    if (Array.isArray(episodesRawResults)) {
                        episodesRawResults.forEach(rawEpisodeResult => {
                            const episodeId = rawEpisodeResult.episode.id.value;
                            const observation = rawEpisodeResult.observation;
                            // find existing episode result if any
                            let episodeResult = episodeResultsSet.find(episodeResult => episodeResult.episodeId === episodeId);
                            if (!episodeResult) {
                                episodeResult = {
                                    episodeId,
                                    populationResults: []
                                };
                                episodeResultsSet.push(episodeResult);
                            }
                            // check if there is already an observation result with this cqlPopulation
                            const observResult = episodeResult.populationResults.find(result => result.populationType === populationType &&
                                result.criteriaExpression === cqlPopulation &&
                                result.criteriaReferenceId === msrPopl.id);
                            if (observResult !== undefined) {
                                // push obs onto an existing populationResult
                                if (observation) {
                                    if (!observResult.observations) {
                                        observResult.observations = [];
                                    }
                                    observResult.observations.push(observation);
                                }
                                observResult.result = true;
                            }
                            else {
                                // create new populationResult with obs
                                // TODO: Episode-level results could probably be just the value, not an array of one value
                                // Future changes to fqm-execution might modify this structure
                                const newPopulationResult = {
                                    populationType: Enums_1.PopulationType.OBSERV,
                                    criteriaExpression: cqlPopulation,
                                    result: true,
                                    observations: [observation]
                                };
                                DetailedResultsHelpers.addIdsToPopulationResult(newPopulationResult, population);
                                episodeResult.populationResults.push(newPopulationResult);
                            }
                        });
                    }
                }
            }
            else {
                // Handle non observation results.
                const rawEpisodeResults = patientResults[cqlPopulation];
                createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, population, populationType);
            }
        }
        else {
            // TODO: Handle this situation of a malformed population
        }
    });
    // loop over stratifications and collect episode results for the strata
    let strataIndex = 1;
    (_b = populationGroup.stratifier) === null || _b === void 0 ? void 0 : _b.forEach(strata => {
        var _a, _b, _c, _d, _e;
        const strataCode = (_c = (_b = (_a = strata.code) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : strata.id) !== null && _c !== void 0 ? _c : `strata-${strataIndex++}`;
        if ((_d = strata.criteria) === null || _d === void 0 ? void 0 : _d.expression) {
            const rawEpisodeResults = patientResults[(_e = strata.criteria) === null || _e === void 0 ? void 0 : _e.expression];
            createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, undefined, undefined, strataCode, strata.id);
        }
    });
    // Correct any inconsistencies. ex. In DENEX but also in NUMER using same function used for patients.
    episodeResultsSet.forEach(episodeResults => {
        episodeResults.populationResults = handlePopulationValues(episodeResults.populationResults, populationGroup, measureScoringCode);
        if (episodeResults.stratifierResults) {
            handleStratificationValues(populationGroup, episodeResults.populationResults, episodeResults.stratifierResults);
        }
    });
    // TODO: Remove any episode that don't fall in any populations or stratifications after the above code
    return episodeResultsSet;
}
exports.createEpisodePopulationValues = createEpisodePopulationValues;
/**
 * Process the raw results from an episode of care population defining statement and fill or create the appropriate
 * entry in the episodeResultsSet
 *
 * @param {any} rawEpisodeResults - Raw population defining statement result. This result should be a list.
 * @param {EpisodeResults[]} episodeResultsSet - EpisodeResults set to populate.
 * @param {fhir4.MeasureGroup} populationGroup - The population group. Used to populate default values for a new encounter.
 * @param {fhir4.MeasureGroupPopulation} population - Used to pass through the criteria expression where present to resolve ambiguities
 * @param {PopulationType} populationType - If this is a regular population the type must be provided.
 * @param {string} strataCode - If this is a stratifier result, the code of the strata must be provided.
 */
function createOrSetValueOfEpisodes(rawEpisodeResults, episodeResultsSet, populationGroup, population, populationType, strataCode, strataId) {
    // Make sure the results are an array.
    if (Array.isArray(rawEpisodeResults)) {
        // Iterate over all episodes
        rawEpisodeResults.forEach((episodeResource) => {
            var _a, _b;
            if (episodeResource.id.value != null) {
                // if an episode has already been created set the result for the population to true
                const episodeResults = episodeResultsSet.find(episodeResults => episodeResults.episodeId === episodeResource.id.value);
                if (episodeResults) {
                    // set population value
                    if (populationType) {
                        (0, ClauseResultsBuilder_1.setResult)(populationType, true, episodeResults.populationResults, population === null || population === void 0 ? void 0 : population.criteria.expression);
                        // set strata value
                    }
                    else if (strataCode) {
                        if (episodeResults.stratifierResults) {
                            const strataResult = episodeResults.stratifierResults.find(strataResult => {
                                return strataResult.strataCode === strataCode;
                            });
                            if (strataResult) {
                                strataResult.result = true;
                                if (strataId) {
                                    strataResult.strataId = strataId;
                                }
                            }
                        }
                    }
                    // else create a new episode using the list of all popcodes for the population
                }
                else {
                    const newEpisodeResults = {
                        episodeId: episodeResource.id.value,
                        populationResults: []
                    };
                    (_a = populationGroup.population) === null || _a === void 0 ? void 0 : _a.forEach(population => {
                        const newPopulationResult = {
                            populationType: MeasureBundleHelpers.codeableConceptToPopulationType(population.code),
                            criteriaExpression: population.criteria.expression,
                            result: false
                        };
                        DetailedResultsHelpers.addIdsToPopulationResult(newPopulationResult, population);
                        newEpisodeResults.populationResults.push(newPopulationResult);
                    });
                    if (populationGroup.stratifier) {
                        newEpisodeResults.stratifierResults = [];
                        let strataIndex = 1;
                        (_b = populationGroup.stratifier) === null || _b === void 0 ? void 0 : _b.forEach(strata => {
                            var _a, _b, _c, _d;
                            const newStrataCode = (_c = (_b = (_a = strata.code) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : strata.id) !== null && _c !== void 0 ? _c : `strata-${strataIndex++}`;
                            (_d = newEpisodeResults.stratifierResults) === null || _d === void 0 ? void 0 : _d.push(Object.assign(Object.assign({}, (strataId ? { strataId } : {})), { strataCode: newStrataCode, result: newStrataCode === strataCode ? true : false, appliesResult: newStrataCode === strataCode ? true : false }));
                        });
                    }
                    // Set the result for the current episode to true
                    if (populationType) {
                        (0, ClauseResultsBuilder_1.setResult)(populationType, true, newEpisodeResults.populationResults, population === null || population === void 0 ? void 0 : population.criteria.expression);
                    }
                    episodeResultsSet.push(newEpisodeResults);
                }
            }
        });
    }
}
/**
 * Set all value set versions to 'undefined' so the execution engine does not grab the specified
 * version in the ELM
 *
 * @param elm List of elm libraries to remove valueSet versions from.
 * @returns The list passed in.
 */
function setValueSetVersionsToUndefined(elm) {
    elm.forEach(elmLibrary => {
        if (elmLibrary.library.valueSets != null) {
            elmLibrary.library.valueSets.def.forEach(valueSet => {
                if (valueSet.version != null) {
                    valueSet.version = undefined;
                }
            });
        }
    });
    return elm;
}
exports.setValueSetVersionsToUndefined = setValueSetVersionsToUndefined;
/**
 * Returns an ELM function to add to the ELM before it is used for calculation. This function is generated
 * for each observation on the measure. It returns a list of tuples, with each episode being observed and the
 * observation for the episode.
 *
 * @param {string} functionName - Name of the observation function. Usually "Measure Observation".
 * @param {string} parameter - Name of the define statement to use as the parameter list. Usually "Measure Population".
 * @returns {ELMStatement} The ELM function to inject into the ELM library before executing.
 */
function generateEpisodeELMJSONFunction(functionName, parameter) {
    const elmFunction = {
        name: `obs_func_${functionName}_${parameter}`,
        context: 'Patient',
        accessLevel: 'Public',
        expression: {
            type: 'Query',
            source: [
                {
                    alias: 'MP',
                    expression: {
                        name: parameter,
                        type: 'ExpressionRef'
                    }
                }
            ],
            relationship: [],
            return: {
                distinct: false,
                expression: {
                    type: 'Tuple',
                    element: [
                        {
                            name: 'episode',
                            value: {
                                name: 'MP',
                                type: 'AliasRef'
                            }
                        },
                        {
                            name: 'observation',
                            value: {
                                name: functionName,
                                type: 'FunctionRef',
                                operand: [
                                    {
                                        name: 'MP',
                                        type: 'AliasRef'
                                    }
                                ]
                            }
                        }
                    ]
                }
            }
        }
    };
    return elmFunction;
}
exports.generateEpisodeELMJSONFunction = generateEpisodeELMJSONFunction;
/*
 * This is used for boolean-based measures that do a measure observation
 * In this case, the function will not have any arguments, so we simplify the generation of
 * this ELM JSON function to simply just call the function rather than do a query
 */
function generateBooleanELMJSONFunction(functionName) {
    const elmFunction = {
        name: `obs_func_${functionName}`,
        context: 'Patient',
        accessLevel: 'Public',
        expression: {
            type: 'FunctionRef',
            name: functionName,
            operand: []
        }
    };
    return elmFunction;
}
exports.generateBooleanELMJSONFunction = generateBooleanELMJSONFunction;
//# sourceMappingURL=DetailedResultsBuilder.js.map